import {
  Button,
  Input,
  Stack,
  Grid,
  Box,
  Center,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
 
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import arrow from "../assets/arrow.svg";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { useEffect, useState } from "react";
import { forgotPassword } from "../components/signupSteps/service";
import { FaRegTimesCircle } from "react-icons/fa";
import { useGetState } from "../context/useGetState";
import splash from "../assets/splash.jpg";


import { BASE_COLOR } from "../constants";

function ForgotPassword() {
  const navigate = useNavigate();
  const textColor = useColorModeValue("#fff", "#fff");
  const [formValues, setFormValues] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const { dispatch } = useGetState();

  useEffect(() => {
    const { email } = formValues || {};
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formValues]);
  // const inputStyle = {
  //   bg: "#fff",
  //   color: "#000",
  //   _placeholder: { color: "#000" },
  // };

  const submit = async (e) => {
    setLoading(true);

    forgotPassword(formValues)
      .then((e) => {
        dispatch({
          signin: true,
          forgotPassword: false,
          resetPassword: true,
          email: formValues?.email,
        });
      })
      .catch((e) => {})
      .finally(() => {
          navigate("/reset/password")
        setLoading(false)});
  };

  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid>
        <Box
          backgroundColor={"#020B19"}
          mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          mt={{
            base: "2em",
            sm: "2em",
            md: "2em",
            lg: "2em",
            xl: "2em",
            "2xl": "2em",
          }}
          h={{
            base: "90vh",
            sm: "85vh",
            md: "90vh",
            lg: "88vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "25px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack
            direction={{ base: "column", md: "row" }}
            mt={{
              base: "5em",
              sm: "5em",
              md: "2em",
              lg: "0em",
              xl: "0em",
              "2xl": "3em",
            }}
          >
            <Flex
              pt={"4%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack spacing={4} w={"full"} maxW={"md"}>
                <Box>
                  <Link to="/register">
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                      mt={"-50px"}
                    />
                  </Link>

                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Forgot Password
                  </Heading>
                  <Flex>
                    <Text
                      fontWeight={400}
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      color={"white"}
                      fontSize={"15px"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Recover your password
                    </Text>
                  </Flex>
                </Box>

                <Stack spacing={"20px"} color={textColor}>
                  <InputGroup size="md">
                    <Input
                 
                      type="email"
                      placeholder="Enter Email"
                      required
                      name="email"
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      value={formValues?.email}
                      onChange={(e) => setFormValues({ email: e.target.value })}
                      autocomplete="off"
                    />
                    <InputRightElement width="4.5rem">
                      <FaRegTimesCircle
                        color="#677185"
                        onClick={() =>
                          setFormValues((prev) => ({ ...prev, email: "" }))
                        }
                        cursor="pointer"
                      />
                    </InputRightElement>
                  </InputGroup>
                  {/* <Button
                    _hover={{ background: BASE_COLOR }}
                    type="submit"
                    onClick={async () => submit()}
                    isLoading={loading}
                    disabled={disabled}
                  >
                    Send verification code
                  </Button> */}
                </Stack>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>

                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      onClick={async () => submit()}
                      isLoading={loading}
                      disabled={disabled}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                    >
                      {loading ? <Spinner /> : "Send code"}
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select
              fontFamily={("Poppins-Regular", "Helvetica")}
              fontSize={".9em"}
              color={"white"}
              w="auto"
            >
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Grid>
    </Center>

  );
}

export default ForgotPassword;
